export default "__VITE_ASSET__DQSH0bpb__"